import { feeConstants } from './constants/feeConstants';

const getFee = () => ({
  type: feeConstants.getFeeRequest,
});

const getFeeParams = (data: any) => ({
  type: feeConstants.getFeeParamsRequest,
  payload: data,
});

const getFeeView = (data: any) => ({
  type: feeConstants.feeViewRequest,
  payload: data,
});

const createFee = (data: any) => ({
  type: feeConstants.createFeeRequest,
  payload: data,
});

const deleteFee = (data: any) => ({
  type: feeConstants.deleteFeeRequest,
  payload: data,
});

const resetCreateFee = () => ({
  type: feeConstants.createFeeReset,
});

const resetDeleteFee = () => ({
  type: feeConstants.deleteFeeReset,
});

const getStudentFeeSummary = (data: { studentId: string; serviceId?: string; enrollmentId?: string }) => ({
  type: feeConstants.getStudentFeeSummaryRequest,
  payload: data,
});

const getEnrollmentFeeHistory = (data: { enrollmentId: string; studentId: string }) => ({
  type: feeConstants.getEnrollmentFeeHistoryRequest,
  payload: data,
});

const resetEnrollmentFeeHistory = () => ({
  type: feeConstants.getEnrollmentFeeHistoryReset,
});

const exportFee = (data: any) => ({
  type: feeConstants.exportFeeRequest,
  payload: data,
});

export const feeActions = {
  getFee,
  getFeeParams,
  getFeeView,
  createFee,
  deleteFee,
  resetCreateFee,
  resetDeleteFee,
  getStudentFeeSummary,
  getEnrollmentFeeHistory,
  resetEnrollmentFeeHistory,
  exportFee,
};
